import {AdminInitialState} from "../interfaces/interfaces";
import {AdminType} from "../interfaces/actionTypes";

const adminInitialState: AdminInitialState = {
  loading: false,
  error: null,
  data: {
    user_id: "",
    username: "",
    role: "",
    email: "",
    token: "",
    expiresIn: "",
    message: "",
    success: false
  },
  accounts: {
    "accounts": {
      "teachers": [],
      "students": []
    }
  }
}

export default function adminReducer(state: AdminInitialState = adminInitialState, action: any): AdminInitialState {
  switch (action.type) {
    case AdminType.LOGIN:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case AdminType.LOGOUT:
      return {
        ...state,
        data: {
          user_id: "",
          username: "",
          role: "",
          email: "",
          token: "",
          expiresIn: "",
          message: "",
          success: false
        },
        loading: false,
        error: null,
        accounts: {
          "accounts": {
            "teachers": [],
            "students": []
          }
        }
      }
    case AdminType.AUTH_ERROR:
      return {
        ...state,
        error: action.payload,
        data: {
          user_id: "",
          username: "",
          role: "",
          email: "",
          token: "",
          expiresIn: "",
          message: "",
          success: false
        },
        accounts: {
          "accounts": {
            "teachers": [],
            "students": []
          }
        },
        loading: false
      }
    case AdminType.GET_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
        loading: false,
        error: null
      }
    case AdminType.LOADING:
      return {
        ...state,
        loading: true
      }
    default:
      return state;
  }
}